const my_profile = {
  viewMyClubSeacretProfile: "Mein ClubSeacret-Profil anzeigen", // translated
  verifiedEmail: "Verifizierte E-Mail", // translated
  unverifiedEmail: "unverifizierte Email", // translated
  viewMoreDetails: "Weitere Details anzeigen", // translated
  createdFrom: "Erstellt ab", // translated
  createdTo: "Erstellt bis", // translated
  selectStatus: "Status auswählen...", // translated
  searchByTitle: "Nach Titel suchen...", // translated
  pushNotifications: "Push-Benachrichtigungen", // translated 
  pushNotificationsDescription: "Browser-Benachrichtigungen für wichtige Updates und Ereignisse erhalten", // translated 
  pushNotificationsNotSupported: "Push-Benachrichtigungen werden in diesem Browser nicht unterstützt", // translated 
  pushNotificationsDeniedMessage: "Die Benachrichtigungsberechtigung wurde verweigert. Bitte aktivieren Sie Benachrichtigungen in Ihren Browsereinstellungen, um Push-Benachrichtigungen zu erhalten.", // translated 
  pushNotificationsEnabled: "Push-Benachrichtigungen erfolgreich aktiviert", // translated 
  pushNotificationsDisabled: "Push-Benachrichtigungen erfolgreich deaktiviert", // translated 
  userInformationMissing: "Benutzerinformationen fehlen", // translated 
  failedToUpdatePushNotifications: "Fehler beim Aktualisieren der Push-Benachrichtigungseinstellungen", // translated 
  notificationPermissionDenied: "Die Benachrichtigungsberechtigung wurde verweigert. Bitte aktivieren Sie sie in Ihren Browsereinstellungen.", // translated 
  notificationPermissionRequired: "Die Benachrichtigungsberechtigung ist erforderlich, um Push-Benachrichtigungen zu aktivieren", // translated 
  notSupported: "Nicht unterstützt", // translated 
  permissionDenied: "Berechtigung verweigert", // translated 
  permissionNotRequested: "Eine Berechtigung ist nicht erforderlich", // translated 
  enabled: "Aktiviert", // translated 
  disabled: "Deaktiviert", // translated 
};


export default my_profile;
